import type { FaireProductEntity } from "../../entity_types/product";

export const p_z98zrpgyeh: FaireProductEntity = {
  token: "p_z98zrpgyeh",
  type: "product",
  name: "Susan Piercing | Hollow Cutout Design Ribbon Knot Stud",
  brandToken: "b_493edh35w5",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/f49f93ea48058383587bb07c8049e1e93fe1c3c138ee2d1f3cab377e8fa831c7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2878446c579de98d276e5c0e45440a64e3e1c3c6682676b12d3ab9d2cd6824da.jpeg",
    "https://cdn.faire.com/fastly/4e14c20d073684e48a87442b9414906fabfd1f68afd65e1068615ddb0493dda3.jpeg",
    "https://cdn.faire.com/fastly/bcbb471f90062a80580f848567258704ee741d0bfaf4ff09da90296cafd8c828.jpeg"
  ],
  priceDollars: 8.32,
  description: "Hollow cutout design ribbon knot stud\nSecure screw closure piercing-type earrings\nDainty and Unique design for everyday wear\n\nPlease note that this earring post thickness of 1.2mm, which is thicker than standard earrings. Make sure to check your piercing size before purchasing.\n\n- Surgical Steel\n- Brass Stud Head\n- 1.2mm post thickness\n- 6mm post length\n- Size: 10x5mm\n- Sold as a Pair ($6/pair)",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:00.969Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
